import { useState } from "react";
import MeasureSideMenu from "@/components/measure/MeasureSideMenu";
import { Category } from "@/types";
import { CombustionList } from "../companies/tabs/combustion/CombustionList";
import { ElectricityList } from "../companies/tabs/electricity/ElectricityList";
import { RechargesList } from "../companies/tabs/recharges/RechargesList";
import { VehiclesConsumption } from "../vehicles/VehiclesComsumption";

export default function MeasureHome() {
  const [selectedCategory, setSelectedCategory] = useState<
    Category | undefined
  >();

  const handleCategorySelect = (category: Category) => {
    setSelectedCategory(category);
  };

  // Render the appropriate component based on the selected category
  const renderCategoryContent = () => {
    if (!selectedCategory) return null;

    switch (selectedCategory?.name?.toLowerCase()) {
      case "combustion":
        return <CombustionList />;
      case "electricity":
        return <ElectricityList />;
      case "vehicles":
        return <VehiclesConsumption />;
      case "recharges":
        return <RechargesList />;
      default:
        return <CombustionList />;
    }
  };

  return (
    <div className="flex h-full">
      {/* Side Menu with Company Selector */}
      <MeasureSideMenu
        onCategorySelect={handleCategorySelect}
        selectedCategoryId={selectedCategory?.id}
      />

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        <div className="sm:flex-auto">{renderCategoryContent()}</div>
      </div>
    </div>
  );
}
